// Func = limiting Scope for this file
var allH = [];

(function(){
	
	function resizeWindow(){
		setTimeout(function() {
			equalize();
		}, 500);
		if(document.getElementsByClassName('ui-datepicker-group').length > 0){
			calendarH();
		}
	}


	//js-booking calendar
	var start = $('#arriveInput').attr('value');
	var end = $('#departureInput').attr('value');
	var firstClick = 0; 

	var limitDate = $('#limitDate').attr('value').split(',');

	$('#datesCalendar').datepicker({
		minDate: start,
		numberOfMonths:2,
		dateFormat: 'mm/dd/yy',
		maxDate: new Date(limitDate[0], parseInt(limitDate[1]) - 1, 31),
		beforeShowDay:function(date){
			$.datepicker._defaults.dateFormat = "mm/dd/yy";
			var startDate = $.datepicker.parseDate('mm/dd/yy', start);
			var endDate = $.datepicker.parseDate('mm/dd/yy', end);
			
			if(date.getTime() == startDate.getTime()){
				return[true,"start-day"];
			} else {
				if(date.getTime() == endDate.getTime()){
					return[true,"end-day"];
				} else {
					if(date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()){
						return[true,"days"];
					} else {
						return[true,""];
					}
				}
			}
		},
		onSelect: function(date){
			var selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date);

			if(firstClick == 0){
				start = date;
				end = date;
				firstClick = 1;
			} else {
				if(selectedDate <= start){
					end =  start;
					start = date;  
				} else {
					end =  date; 
				}
				firstClick = 0;
			}

			$('#arriveInput').attr('value',start);
			$('#departureInput').attr('value',end);
			setTimeout(function(){
				calendarH();
			},10)
		},
		onChangeMonthYear: function(){
			setTimeout(function(){
				calendarH();
			},40)
		}
	});
	//booking selectors change for adults and children
	let allSelectors = document.getElementsByClassName('js-selector');
	let allSelectorsLength = allSelectors.length;
	for(let t=0; t < allSelectorsLength; t++){
		allSelectors[t].addEventListener('click', function(){
			let movement = this.getAttribute('data');

			if(movement == 'down'){
				let SelectorNumber = parseInt(this.nextElementSibling.innerHTML,10);
				SelectorNumber--;
				if(SelectorNumber >= 0){
					this.nextElementSibling.innerHTML = '0' + SelectorNumber;
					$('input[name="'+this.nextElementSibling.getAttribute('data')+'"]').attr('value', SelectorNumber);
				}
			} else {
				let SelectorNumber = parseInt(this.previousElementSibling.innerHTML,10);
				SelectorNumber++;
				if(this.previousElementSibling.getAttribute('data') == 'adult'){
					var selectorLimit = 4;
					
				} else {
					var selectorLimit = 3;
					
				}
				if(SelectorNumber <= selectorLimit){
					this.previousElementSibling.innerHTML = '0' + SelectorNumber;
					$('input[name="'+this.previousElementSibling.getAttribute('data')+'"]').attr('value', SelectorNumber);
				}
			}

		});
	}
	
	
	function checkReplaceBooking() {
		if( $('.ot-time-picker').length && $('.ot-button').length && $('.ot-party-size-picker select option').length && $('.ot-party-size-picker a').length ) {
			$('.ot-button').val('RESERVE A TABLE');
			$('.ot-party-size-picker a').html( $('.ot-party-size-picker a').html().replace(/person|people/i, ''));
			$('.ot-party-size-picker select option').each(function() {
				$(this).html( $(this).html().replace(/person|people/i, '') );
			});
			$('.ot-time-picker select option').each(function() {
				$(this).html( $(this).html().toLowerCase() );
			});
			$('.containerInputs').css('display', 'block');
		} else {
			setTimeout(checkReplaceBooking, 250);
		}
	}
	

	//spa treatments page
	if(document.getElementsByClassName('spa-treatments').length > 0){
		let allsubmenuLi = document.getElementsByClassName('secondary-menu')[0].getElementsByTagName('li');
		for(let h = 0; h < allsubmenuLi.length; h++){
			if(allsubmenuLi[h].getElementsByTagName('a')[0].innerHTML == 'Spa Treatments'){
				allsubmenuLi[h].getElementsByTagName('a')[0].classList.add('active');
			}
		}
	}

	$(document).ready(function () {

		//hardcoded popin
		if(document.getElementsByClassName('special-popin').length > 0){
			setTimeout(function(){
				document.getElementsByClassName('special-popin')[0].classList.add('visible');
			}, 300);
			document.getElementsByClassName('special-popin__call')[0].addEventListener('click', function(){
				document.getElementsByClassName('special-popin__content')[0].classList.add('active')
			})
			document.getElementsByClassName('closepopin')[0].addEventListener('click', function(){
				document.getElementsByClassName('special-popin__content')[0].classList.remove('active')
			})
		}

		//Call function with browser is resized.
		$(window).resize(function (event) {
			resizeWindow();
		});
		resizeWindow();

		setTimeout(function(){
			if($('.topalert').length > 0){
				$('body').addClass('withalert')
			}
		}, 600)

		

		//Acts when scroll down page.
		$(window).scroll(function (event) {
			var top = $(document).scrollTop();		
			if (top > 100) {
				$('#header').addClass('scroll');
				$('.gallery__tag-list').addClass('scroll');
				//$('#gallery-wrapper .grid-item-filter.grid-item-0').css('margin-top','-111px');
			} else {
				$('#header').removeClass('scroll');
				//$('#gallery-wrapper .grid-item-filter.grid-item-0').css('margin-top','-51px');
				$('.gallery__tag-list').removeClass('scroll');
			}
			var subtop = ($('#top-content').height() - $('#header').height()) + 122;
			if ($(this).scrollTop() > subtop) {
				$('#bottom-content').addClass('nav-add');
			} else {
				$('#bottom-content').removeClass('nav-add');
				$('.secondary-menu .sub-menu').fadeIn(150);
				$('#third-menu').fadeIn(150);
			};	
		});
		checkReplaceBooking();
		/*Add Book Now Button in Primary Menu*/
		//$("#header #primary-nav ul#privary-navigation").append('<li class="primary-nav-8"><a href="https://be.synxis.com/?hotel=77817&chain=16684" id="buttonTrigger" class="btn booking-trigger bookNow-menu" target="_blank">RESERVE</a></li>');
		//$("#header #primary-nav ul#privary-navigation").append('<li class="primary-nav-8"><a href="#" id="buttonTrigger" class="js-booking-cta">RESERVE</a></li>');
		//booking show  js-booking-cta
		document.getElementsByClassName('js-booking-cta')[0].addEventListener('click', function(e){
			e.preventDefault();
			document.getElementsByClassName('js-booking-block')[0].classList.add('open');
		});
		document.getElementsByClassName('js-booking-close')[0].addEventListener('click', function(){
			document.getElementsByClassName('js-booking-block')[0].classList.remove('open');
		});



		$('#footer .social-media li:nth-child(2)').insertBefore('#footer .social-media li:nth-child(1)');
		let locationMenu = location.pathname.replace('indian-springs-calistoga/','');
		locationMenu = locationMenu.split('/')
		// Main Nav Dropdown
		$("#primary-nav li").hover(function(){
			let navigation = $(this).context.firstElementChild.href.split('/')
			if(navigation[navigation.length-1] == locationMenu[1]){
				$(this).removeClass("hover");
				$('ul.submenu',this).fadeOut(200);
			}else{
				$(this).addClass("hover");
				$('ul.submenu',this).fadeIn(200);
			}
		}, function(){
			$(this).removeClass("hover");
			$('ul.submenu',this).fadeOut(200);		
		});

		//Add class to secondary menu when have third menu
		// if($('#third-menu').length > 0){
		// 	$('.secondary-menu .sn-1 a').addClass('active');
		// }
		if($('#gallery-wrapper').length > 0){
			// Init Isotope Grid
			// var $grid = $('.grid').isotope({
			// 	percentPosition: true,
			// 	itemSelector: '.grid-item-image',
			// 	stagger: 130,
			// 	transitionDuration: 0,
			// 	transformsEnabled: false,
			// 	hiddenStyle: {
			// 		opacity: 0,
			// 		// transform: 'scale(0.001)'
			// 		transition: 'all 0s ease-in-out'
			// 	  },
			// 	  visibleStyle: {
			// 		opacity: 1,
			// 		// transform: 'scale(1)'
			// 		transition: 'all 0s ease-in-out'
			// 	  }
			// });
			// $("#myGallery, #gallery-wrapper").css("margin-top", HeightTopHeader + 51);
			// $grid.isotope();
		}

		//home slider animation
		if($('body#home').length > 0){
			setTimeout(function(){
				$('#home .top-content').addClass('shown');
			}, 1000)
			setTimeout(function(){
				$('#home .intro-content-home').addClass('shown');
			}, 200)
		} else{ 
			setTimeout(function(){
				$('#top-content').addClass('shown');
			}, 1000)
		};


		setTimeout(function(){
			$('iframe[name="frame-cart"]').attr('title','cart shopping');
			$('a[href*="frequently-asked-questions"]').attr('aria-label','Pool frequently asked questions');
			$('a[href*="spa-frequently-asked-questions"]').attr('aria-label','faq -  Spa frequently asked questions');
			$('iframe[name="frame-toggle"]').attr('title','frame-toggle');
			$('iframe[src="https://bid.g.doubleclick.net/xbbe/pixel?d=KAE"]').attr('title','toggle');
			$('iframe[src="https://static.triptease.io/message-porter/dist/storageIframe.html"]').attr('title','toggle');
			$('iframe[name="frame-cart"]').attr('border','1');
			$('iframe[name="frame-toggle"]').attr('border','1');
			$('iframe[src="https://static.triptease.io/message-porter/dist/storageIframe.html"]').attr('border','1');
			$('iframe[src="https://bid.g.doubleclick.net/xbbe/pixel?d=KAE"]').attr('border','1');
			$('#privary-navigation li a.navisTFN').removeClass('active');
			$('#privary-navigation li a.navisTFN').attr('aria-label','(844) 378-3635 Header Phone')
		}, 500)
		
		//Terms Toggle
		showContent($('.toggle-terms'), $('.terms-container'),'active');

		// SPECIALS BEHAVIOUR
		$('.special_more').hide();
		$('.special_view').click(function(e){
			e.preventDefault();
			var first_element = 0;
			if($( this ).parent('.copy-holder').parent('.copy-side').hasClass('first-element')){
				first_element = 115;
			}
			var height_total = getHeight($(this).next('.special_more')[0]) + $( this ).parent('.copy-holder').height() + first_element;
			$( this ).parent('.copy-holder').parent('.copy-side').css('height',height_total) ;
	    	$(this).next('.special_more').slideDown();
			$(this).hide();
			if($( this ).parent('.copy-holder').hasClass('center')){
				$( this ).parent('.copy-holder').removeClass('center');
				// setTimeout(function(){
				// 	equalize()
				// }, 500)
			}
	    });
	    $('.special_hide').click(function(e){
	    	e.preventDefault();
	    	$(this).parent('.special_more').slideUp();
			$('.special_view').show();
			if(!$( this ).parent('.special_more').parent('.copy-holder').hasClass('center')){
				$( this ).parent('.special_more').parent('.copy-holder').addClass('center');
				setTimeout(function(){
					equalize()
				}, 500)
			}
		});
		var getHeight = function(el) {
			var el_style      = window.getComputedStyle(el),
				el_display    = el_style.display,
				el_position   = el_style.position,
				el_visibility = el_style.visibility,
				el_max_height = el_style.maxHeight.replace('px', '').replace('%', ''),		
				wanted_height = 0;		
			// if its not hidden we just return normal height
			if(el_display !== 'none' && el_max_height !== '0') {
				return el.offsetHeight;
			}		
			// the element is hidden so:
			// making the el block so we can meassure its height but still be hidden
			el.style.position   = 'absolute';
			el.style.visibility = 'hidden';
			el.style.display    = 'block';		
			wanted_height     = el.offsetHeight;		
			// reverting to the original values
			el.style.display    = el_display;
			el.style.position   = el_position;
			el.style.visibility = el_visibility;		
			return wanted_height;
		};
		//Properties Day's Calendar [Enable/Disable,ClassName,Tooltip]
		let DATE_STYLE = [true];
		function calendarRange(date){			
			let d1=$.datepicker.parseDate(DATE_FORMAT,$('#CheckIn').val());		
			let d2=$.datepicker.parseDate(DATE_FORMAT,$('#CheckOut').val());
			if (d1 && date.getTime() == d1.getTime() || d2 && date.getTime() == d2.getTime()) {
				DATE_STYLE[1] = 'highlight-top';
			}else if(date > d1 && date < d2){
				DATE_STYLE[1] = 'highlight';
			}else{
				DATE_STYLE[1] = '';
			}
			return DATE_STYLE;
		}

		//Check in and check out datepicker for booking engine
		const DATE_FORMAT = ($("#CheckIn").data("format") !== undefined && $("#CheckIn").data("format")) ? $("#CheckIn").data("format") : "yy-mm-dd";		
        $( "#CheckIn" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
			changeMonth: true,
            dateFormat: DATE_FORMAT,
            numberOfMonths: 1,
			minDate: 0,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				let getDate = $(this).datepicker('getDate');
				let newDate = new Date(getDate.getTime());
				newDate.setDate(newDate.getDate() + 3);
				$( "#CheckOut" ).datepicker( "setDate", newDate );
				$( "#CheckOut" ).datepicker( "option", "minDate", selectedDate );
			}
		});
		$( "#CheckOut" ).datepicker({
			//showOn: "both",
			//buttonImage: SITE_FILES+"images/img-calendar-gray.png",
			//buttonImageOnly: true,
            dateFormat: DATE_FORMAT,
            changeMonth: true,
			numberOfMonths: 1,
			beforeShowDay: (date) => calendarRange(date),
			onSelect: function( selectedDate ) {
				//$( "#CheckIn" ).datepicker( "option", "maxDate", selectedDate );
			}
		});

		$('#third-nav').removeAttr('aria-labelledby');
		$('#third-nav').removeAttr('aria-label');

		$('#primary-nav').removeAttr('aria-label');

		$('#secondary-nav').removeAttr('aria-label');

		$('.form-label').removeAttr('aria-label');

		// Map: Return to previous page button. Change body id to match map template's name.
		//$('body#map-category-sidebar #content').prepend('<a class="btn return-from-map" href="javascript:history.back()">« Back to previous page</a>');

		//DROPDOWN STYLE
		//$('select').niceSelect();		
		
	});

	$(window).on('load', function() {});

}());
function initSlider(){
	$('.sym-slides-tags').slick({
		arrows:false,
		dots:false,
		autoplay:false,
		draggable:false,
		autoplaySpeed: 4000,
		accessibility:false
	});
	$('.sym-slides-container-tags').slick({
		arrows:false,
		dots:true,
		autoplay:false,
		draggable:false,
		autoplaySpeed: 4000,
		accessibility:false
	});
	setTimeout(function() {
		equalize({reset: true});
	}, 500);
	var lazyImages = [].slice.call(document.querySelectorAll('.animate-fade') || []);
	var active = false;

	function _intersectionObserver() {
		if (!active) {
			active = true;
			// setTimeout(function () {
				lazyImages.forEach(function (image) {
					var imageBoundingClientRect = image.getBoundingClientRect();
					if (imageBoundingClientRect.top <= window.innerHeight && imageBoundingClientRect.bottom >= 0) {
						if( !image.classList.contains('animate-fade')  ) image.classList.contains('lazyinlinebg') ? image.style.backgroundImage = 'url(' + image.dataset.srcset + ')' : image.src = image.dataset.srcset;

						if( !image.classList.contains('animate-fade')  ){
							image.classList.add('visible');
						}else{
							image.classList.add('fade-in');
						}
						lazyImages = lazyImages.filter(function (_image) {
							return image !== _image;
						});
					}

					if (lazyImages.length === 0) {
						document.removeEventListener('scroll', _intersectionObserver);
						window.removeEventListener('resize', _intersectionObserver);
						window.removeEventListener('orientationchange', _intersectionObserver);
					}

					active = false;
				});
			// }, 0);
		}
	}

	if (lazyImages.length > 0) {
		document.addEventListener('scroll', _intersectionObserver);
		window.addEventListener('resize', _intersectionObserver);
		window.addEventListener('orientationchange', _intersectionObserver);
	}

	_intersectionObserver();
}
function navisEmailSignup(formID) {

	$.post(site_url + 'ajax/emailsignup.php',$("#" + formID).serialize(), function(data){
		if(data.error) {
			if (formID == 'email-signup2') {
				$("#email-error2").html(data.msg);
			} else {
				$("#email-error").html(data.msg);
			}


		} else {
			//ga('send', 'event', 'form', 'click', 'specials');
			$("#"+formID).html('<p>Thank You</p>');

		}
	},'json');
}

function calendarH() {
	allH = [];
	$('.ui-datepicker-group').each(function(){
		$(this).css('height','auto');
		allH.push($(this).height());
	});
	let tallestP = allH.reduce(function(a,b){
		return a > b ? a : b;
	},{});
	$('.ui-datepicker-group').each(function(){
		$(this).css('height',tallestP + 10 + 'px');
	});
}

function adaPerforemance () {
	const allRole = document.querySelectorAll('[role]');
	const navLabel = document.querySelectorAll('nav[aria-label], [aria-labelledby]');
	if(allRole && allRole.length > 0) allRole.forEach(el => el.removeAttribute('role'));
	if(navLabel && navLabel.length > 0) navLabel.forEach(el => {
		el.removeAttribute('aria-label');
		el.removeAttribute('aria-labelledby');
	});
} 

window.onload = adaPerforemance();